import { useEffect, useRef, useCallback } from "react";

export function useDeliveryDateChangeAlert({ cart, onAutoChange, enabled = true }) {
  const prevDeliveryDateRef = useRef(undefined);
  const prevCustomerIdRef = useRef(undefined);
  const userChangedRef = useRef(false);

  const markUserChange = useCallback(() => {
    userChangedRef.current = true;
  }, []);

  const reset = useCallback(() => {
    prevDeliveryDateRef.current = cart?.delivery_date;
    prevCustomerIdRef.current = cart?.customer_id;
    userChangedRef.current = false;
  }, [cart?.delivery_date, cart?.customer_id]);

  useEffect(() => {
    if (!enabled) return;

    const currentCustomerId = cart?.customer_id; // int (loggato) o uuid (temp)
    const currentDeliveryDate = cart?.delivery_date;

    // primo giro / cart ancora non pronto: inizializza silenzioso
    if (prevCustomerIdRef.current === undefined && prevDeliveryDateRef.current === undefined) {
      prevCustomerIdRef.current = currentCustomerId;
      prevDeliveryDateRef.current = currentDeliveryDate;
      userChangedRef.current = false;
      return;
    }

    // Se cambia customer_id => è un "cart swap" (temp->user o viceversa). Niente popup.
    if (prevCustomerIdRef.current !== currentCustomerId) {
      prevCustomerIdRef.current = currentCustomerId;
      prevDeliveryDateRef.current = currentDeliveryDate;
      userChangedRef.current = false;
      return;
    }

    // Stesso carrello: se cambia la data, valuta popup
    if (prevDeliveryDateRef.current !== currentDeliveryDate) {
      if (!userChangedRef.current) {
        onAutoChange?.(prevDeliveryDateRef.current, currentDeliveryDate, cart);
      }
      prevDeliveryDateRef.current = currentDeliveryDate;
      userChangedRef.current = false;
    }
  }, [cart?.customer_id, cart?.delivery_date, cart, onAutoChange, enabled]);

  return { markUserChange, reset };
}
